// src/components/ScrollRestoration.jsx
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollRestoration() {
  const location = useLocation();
  const scrollPositions = useRef({});

  useEffect(() => {
    return () => {
      scrollPositions.current[location.key] = window.scrollY;
    };
  }, [location]);

  useEffect(() => {
    const y = scrollPositions.current[location.key];
    if (y !== undefined) {
      requestAnimationFrame(() => {
        window.scrollTo(0, y);
      });
    }
  }, [location]);

  return null;
}
